import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../../services/authentication.service';

@Component({
  selector: 'app-xerocallback',
  templateUrl: './xerocallback.component.html',
  styleUrls: ['./xerocallback.component.scss']
})
export class XerocallbackComponent {
  error: boolean = false;
  errorMessage: string = "";
  isLoading: boolean = false;

  isPageLoading: boolean = true;
  isSignupSuccess: boolean = false;
  isSignupSuccessMessage_Email: string = '';
  isSignupSuccessMessage_Name: string = '';
  isSignupErrorMessage: string = '';

  isLoginWithXero: boolean = false;
  hasLoginToken: boolean = false;

  constructor(
    public authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    // -- For HTML testing
    // this.isSignupSuccess = true;
    // this.isPageLoading = false;
    // this.isSignupSuccessMessage_Email = 'jandre@hubtiger.com';
    // this.isSignupSuccessMessage_Name = 'ORGANIZATION';
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const code = params['code'];
      if (code) {
        //Has code in url, exchange code for token 
        this.exchangeCodeForToken(code);
      }
      else {
        //No code in url, check errors
        const error = params['error'];
        const description = params['error_description'];

        if (error) {
          this.hasError(error, description);
        }
        else {
          this.hasError('Invalid response to handle', null);
        }
      }
    });
  }

  hasError(error, description) {
    if (description == null || description == "") {
      description = "Xero error unknown";
    }

    this.error = true;
    this.errorMessage = `${error} - ${description}`;

    this.isSignupSuccess = false;
    this.isSignupErrorMessage = `An error occured while we tried to finalize your HUBTIGER account using the Xero sign-up process.`;
    this.isPageLoading = false;
  }

  exchangeCodeForToken(code) {
    this.error = false;
    this.errorMessage = "";

    this.authenticationService.xeroExchangeToken(code).subscribe(response => {
      console.log(response);
      if (response.token) {
        //Login using xero
        this.isLoginWithXero = true;
        //Need new identity to use this
        // if (response.token == null || response.token == "") {
        //   this.hasLoginToken = false;
        // }
        // else {
        //   this.hasLoginToken = true;
        // }
        this.hasLoginToken = false;
        this.isPageLoading = false;
      }
      else {
        //New xero sign up
        this.isSignupSuccess = true;
        this.isSignupSuccessMessage_Name = response.name;
        this.isSignupSuccessMessage_Email = response.email;
        this.isPageLoading = false;
      }
    },
      err => {
        this.error = true;
        this.errorMessage = err;

        this.isSignupSuccess = false;
        this.isSignupErrorMessage = `We could not finalize your HUBTIGER account using the Xero sign-up process.`;
        this.isPageLoading = false;
      });
  }

  tryAgain() {
    this.isLoading = true;
    this.router.navigateByUrl('/xero/signup');
  }

  signInHubtiger() {
    this.isLoading = true;
    this.router.navigateByUrl('/');
  }
}
